import React, { Component } from 'react';
import { Translate } from 'react-redux-i18n';
import { Button } from 'react-bootstrap';
import _ from 'lodash';
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import checkPermission from './permissions';
import { getFromToDates } from './cleanDates';
import { ROOT_URL, ROOT_API_URL, companyCodeTitle } from '../../actions/root_url';
import { is } from 'immutable';


class Calendar extends Component {
  static contextTypes = {
    router: React.PropTypes.object,
  };

  constructor() {
    super();
    this.state = {
      selectedDay: new Date(),
    };
    this.renderDay = this.renderDay.bind(this);
    this.onMonthChange = this.onMonthChange.bind(this);
    this.renderButton = this.renderButton.bind(this);
  }

  onMonthChange(date) {
    const dates = getFromToDates(date, 'month');
    this.props.fetchInfo('month', dates);
  }

  handleDayClick = (day, { disabled, selected }) => {
    if (disabled) {
      return;
    }
    this.setState({
      selectedDay: selected ? null : day,
    })
  }

  sundays(day) {
    return day.getDay() === 0;
  }

  dateFormatter(day) {
    const y = day.getFullYear().toString();
    let m = day.getMonth() + 1;
    if (m < 10) {
      m = '0' + m;
    } else {
      m = m.toString();
    }
    let d = day.getDate();
    if (d < 10) {
      d = '0' + d;
    } else {
      d = d.toString();
    }
    return y + m + d;
  }

  isPermitted = (message) => {
    if (message === 'edit') {
      return checkPermission('change_price_reference');
    } else if (message === 'view') {
      return checkPermission('view_price_reference');
    }
    return false;
  }

  renderButton(day) {
    const d = this.dateFormatter(day);
    const todayD = this.dateFormatter(new Date())
    const message = (d < todayD) ? 'view' : 'edit';
    let permission = this.isPermitted(message);

    let handleButtonClick = () => {
      if (this.props.type === 'priceAdjustment') {
        const dates = getFromToDates(day);
        this.props.fetchInfo('day', dates);
        this.context.router.push(this.props.url);
        permission = this.isPermitted(message);
      } else if (this.props.type === 'purchasePivotChart') {
        this.props.fetchPurchasePivotCharts(d);
        this.props.openChartModal(d);
        this.props.selectDate(d);
      }
    };
    if (d <= todayD) {
      return (
        <Button bsStyle="primary" onClick={handleButtonClick} disabled={!permission}><Translate value={message} /></Button>
      );
    }
  }
  renderDay(day) {
    const date = day.getDate();
    let d = date.toString();
    if (date < 10) {
      d = '0' + d;
    }
    const renderButton = this.renderButton;
    const index = _.findIndex(this.props.data, {Date: d})
   

console.log(this.props.type)
{
  if (index > -1 && this.props.type === "priceAdjustment") {
  return (
    <div>

      <div className="date">{date}</div>

      <div>
        <Translate value="done" /> {this.props.data[index].Done}
      </div>
      
      <div>
        <Translate value="pass" /> {this.props.data[index].Pass}
      </div>

      <div>
        <Translate value="update" /> {this.props.data[index].Update}
      </div>

      <div>
        <Translate value="undone" /> {this.props.data[index].Undone}
      </div>
      ;

          { renderButton(day) }
        </div>
      );
    } else if (index > -1 && this.props.type === "purchasePivotChart") {
      return (
        <div>
          <div className="date">{date}</div>
          <div>
            {this.props.data[index].Order} <Translate value="orders" />
          </div>
          { renderButton(day) }
        </div>
      );
    }
    return (
      <div>
        <div className="emptyDate">{date}</div>
      </div>
    );
  }
  }
  render() {
    return (
      <DayPicker
        initialMonth={new Date()}
        selectedDays={this.state.selectedDay}
        onDayClick={this.handleDayClick}
        onMonthChange={this.onMonthChange}
        renderDay={this.renderDay}
      />
    );
  }
}

export default Calendar;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/calendar.jsx